'use strict';

import {
    PANELMANAGER_CLOSE_POPUP,
    PANELMANAGER_CLOSE_POPUP_FINISH
} from '../../constants';
import {
    AppDispatch,
    StoreState,
    Thunk
} from '~/frontend/src/store';
import cancelRequests from '~/frontend/src/actions/ajax/cancelRequests';
import clearAjaxError from '~/frontend/src/actions/ajax/clearAjaxError';
import clearAjaxErrorForSubpanels from '~/frontend/src/actions/ajax/clearAjaxErrorForSubpanels';
import {
    clearElusiveData,
    clearElusiveDataForSubpanels
} from '~/frontend/src/actions/elusiveData';
import {
    panelClasses,
    PanelType,
    PanelClass
} from '~/frontend/src/components/base/page/PageTabPanel/definitions';
import {getPanelProps} from '~/frontend/src/components/base/page/PageTabPanel/utilities';


export type ClosePopupAction = {
    type : typeof PANELMANAGER_CLOSE_POPUP,
    panelKey : string
};
export type ClosePopupFinishAction = {
    type : typeof PANELMANAGER_CLOSE_POPUP_FINISH,
    panelKey : string
};

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 */
const closePopup = ( panelKey : string ) : Thunk<Promise<void>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<void> => {
    const panelProps          = getPanelProps( panelKey )?.panelProps,
          panelType           = panelProps?.panelType,
          PanelComponentClass = panelType ? panelClasses[ panelType as PanelType ] as unknown as PanelClass : undefined;

    dispatch( {
        type: PANELMANAGER_CLOSE_POPUP,
        panelKey
    } );

    // has panel a close action -> dispatch it
    if ( PanelComponentClass?.onClosePanelAction ) {
        await dispatch( PanelComponentClass.onClosePanelAction( { ...panelProps, uid: panelKey } ) );
    }

    dispatch( cancelRequests( panelKey ) );
    dispatch( clearAjaxError( panelKey ) );
    dispatch( clearAjaxErrorForSubpanels( panelKey ) );
    dispatch( clearElusiveData( panelKey ) );
    dispatch( clearElusiveDataForSubpanels( panelKey ) );

    delete global.data[ panelKey ];
    delete global.data[ panelKey + '-meta' ];

    dispatch( {
        type: PANELMANAGER_CLOSE_POPUP_FINISH,
        panelKey
    } );
}
export type ClosePopup = typeof closePopup;

export default closePopup;
